/**
 * 特殊文字のエスケープ
 * @param text HTML文字列
 * @returns エスケープ処理したHTML文字列
 */
export function sanitize(text: undefined | null | string): string {
  if (!text) return '';

  return text
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/(?:\r\n|\r|\n)/g, '<br />');
}
